import React from 'react';
import PropTypes from 'prop-types';
import EditButton from '../../../common/button/EditButton';
import { DRIVER_COMMISSION_PATH } from '../../../../config/paths';
import DriverCommissionDeleteButton from './DriverCommissionDeleteButton';

const DriverCommissionToolbar = ({ driverCommissionId }) => (
  <div className="pull-right">
    <EditButton path={`${DRIVER_COMMISSION_PATH}/${driverCommissionId}/edit`}>
      Editar
    </EditButton>{' '}
    <DriverCommissionDeleteButton driverCommissionId={driverCommissionId}>
      Eliminar
    </DriverCommissionDeleteButton>
  </div>
);

DriverCommissionToolbar.propTypes = {
  driverCommissionId: PropTypes.number.isRequired,
};

DriverCommissionToolbar.defaultProps = {};

export default DriverCommissionToolbar;
